// extracted by mini-css-extract-plugin
export default {"container":"theme_container__EsHXC","tab":"theme_tab__BVeFK","active":"theme_active__kynqa"};